import { filter } from "lodash";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import iconEdit from "@iconify/icons-eva/edit-2-fill";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import { useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Switch, Button, Checkbox, TableRow, TableBody, TableCell, Container, Typography, TableContainer, TablePagination, RadioGroup, Radio, FormControlLabel, TextField } from "@mui/material";
// components
import Page from "../../components/Page";
import Label from "../../components/Label";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import { alert } from "src/services/alert";
import Confirm from "src/components/common/ConfirmDialog";
import MyPagination from "src/components/common/MyPagination";
import ListHead from "src/components/common/ListHead";
import CellImage from "src/components/common/CellImage";
import ListToolbar from "src/components/common/ListToolbar";
import { asyncRequest } from "src/services/network";
import QRCode from "qrcode";
import { BASE_URL } from "src/config/constants";

const map = {
  PAYMENT_DOWNLOAD: "支付订单",
  USER_DOWNLOAD: "用户信息",
  XFQ_RECORD_DOWNLOAD: "权益金明细",
  DHQ_RECORD_DOWNLOAD: "兑换券明细",
  EQUITY_VALUE_RECORD_DOWNLOAD: "权益值明细",
  FREE_BENEFIT_RECORD_DOWNLOAD: "免费权益积分明细",
  CONTRIBUTION_PRICE_HISTORY_DOWNLOAD: "贡献值单价记录",
  POINT_RECORD_DOWNLOAD: "积分记录",
  MERCHANT_DOWNLOAD: "商户明细",
  MERCHANT_EXPORT: "商户信息",
  AGENT_SALARY_DOWNLOAD: "代理工资单",
  TRANSACTION_DOWNLOAD: "交易流水",
  DUIFU_RECORD_DOWNLOAD: "兑付记录",
  JYT_DRAGON_BEAD_LOG: "银豆日志",
  JYT_BATCH_COIN_RECHARGE: "批量拨付金豆",
  JYT_VIP_LIST: "金银通VIP列表",
  JYT_VIP_LOG: "VIP开通日志",
  STORE_ORDER: "商城订单",
};

const TABLE_HEAD = [{ id: "id", label: "ID", alignRight: false }, { id: "jobId", label: "任务号", alignRight: false }, { id: "rows", label: "行数", alignRight: false }, { id: "category", label: "类别", alignRight: false }, { id: "status", label: "状态", alignRight: false }, { id: "updatedAt", label: "生成时间", alignRight: false }, { id: "" }];

const moreMenus = [{ title: "下载", icon: iconDelete }];

export default function DownloadList() {
  const [selected, setSelected] = useState([]);
  const navigate = useNavigate();

  const [action, setAction] = useState("");
  const [form, setForm] = useState({
    amount: "",
  });

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 1,
    size: 10,
    search: "",
  });

  const [uri, setUri] = useState("");
  const [payUrl, setPayUrl] = useState("");

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "task/download/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "下载") {
      downloadItem(row);
    }
  };

  async function downloadItem(row) {
    const blob = await asyncRequest({
      path: "task/download/download",
      data: {
        jobId: row.jobId,
      },
    });

    console.log(blob);

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = row.jobId + ".xlsx";
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  const isUserNotFound = items.length === 0;

  return (
    <Page title="下载中心">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            下载中心
          </Typography>
        </Stack>

        <Card>
          <ListToolbar filterName={filter.search} onRefresh={getItems} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />

                <TableBody>
                  {items.map((row) => {
                    const { id, total, remaining, payTime, icon, jobId, rows, category, status, updatedAt } = row;
                    const isItemSelected = selected.indexOf(icon) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                        <TableCell align="left">{id}</TableCell>
                        <TableCell align="left">{jobId}</TableCell>
                        <TableCell align="left">{rows}</TableCell>
                        <TableCell align="left">{map[category]}</TableCell>
                        <TableCell align="left">{["未完成", "已完成", "已失败"][status]}</TableCell>
                        <TableCell align="left">{moment(updatedAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>

                        <TableCell align="right">
                          {/* <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} /> */}
                          {status == 1 && (
                            <Button variant="contained" download href={BASE_URL + row.filePath}>
                              下载
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>
    </Page>
  );
}
